import { render, staticRenderFns } from "./AssetViewer.vue?vue&type=template&id=58f13004&scoped=true&"
import script from "./AssetViewer.vue?vue&type=script&lang=js&"
export * from "./AssetViewer.vue?vue&type=script&lang=js&"
import style0 from "./AssetViewer.vue?vue&type=style&index=0&id=58f13004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f13004",
  null
  
)

export default component.exports